import { rewriteUrl } from "../../shared/rewriters/url";
import { VortexClient } from "@client/index";

export default function (client: VortexClient) {
	client.Proxy("importScripts", {
		apply(ctx) {
			for (const i in ctx.args) {
				ctx.args[i] = rewriteUrl(ctx.args[i], client.meta);
			}
		},
	});
}
